<div class="marv_radio" 
    [class.inline]="this.inlineRadio"
    [class.label_end]="this.labelPlacement === 'end'"
    [class.checked]="(this.formGroupDirective.form.controls[this.formName] && this.formGroupDirective.form.controls[this.formName].value)">
    <label>
        <div class="marv_radio_container">
            <div class="marv_radio_checkmark"></div>
            <input type="radio" [value]="this.valueRadio" [name]="this.formName" [formControlName]="this.formName"/>
        </div>
        {{this.labelRadio}}
    </label>
</div>

@if(this.errorText !== '' 
    && this.formGroupDirective.form.controls[this.formName] 
    && this.formGroupDirective.form.controls[this.formName].touched 
    && this.formGroupDirective.form.controls[this.formName].errors){
    <div class="marv_input_error">{{this.errorText}}</div>
}